@if (!loading) {
  <div class="edit-user-container">
    <h2 class="titleBar">{{ "Edit User" | translate }}</h2>
    <form
      [formGroup]="formGroup"
      (ngSubmit)="saveChanges()"
      class="edit-user-form"
      >
      <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
        <div fxLayout="col" fxFlex="50" class="add-patient-col">
          {{ "First name" | translate }}
          <span class="required-asterisk">*</span>
        </div>
        <div fxLayout="col" fxFlex="50" class="add-patient-col">
          {{ "Last name" | translate }}
          <span class="required-asterisk">*</span>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
        <div fxLayout="col" fxFlex="50" class="add-patient-col">
          <input
            class="add-patient-input"
            [placeholder]="'First name' | translate"
            formControlName="firstName"
            [maxlength]="51"
            />
          </div>
          <div fxLayout="col" fxFlex="50" class="add-patient-col">
            <input
              class="add-patient-input"
              [placeholder]="'Last name' | translate"
              formControlName="lastName"
              [maxlength]="51"
              />
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
            <div fxLayout="col" fxFlex="50" class="add-patient-col">
              {{ "Username" | translate }}
              <span class="required-asterisk">*</span>
            </div>
            <div fxLayout="col" fxFlex="50" class="add-patient-col">
              {{ "Phone Number" | translate }}
              <span class="required-asterisk">*</span>
            </div>
          </div>
          <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
            <div fxLayout="col" fxFlex="50" class="add-patient-col">
              <input
                class="add-patient-input"
                [placeholder]="'Username' | translate"
                formControlName="username"
                [maxlength]="101"
                />
              </div>
              <div fxLayout="col" fxFlex="50" class="add-patient-col">
                <ngx-intl-tel-input
                  [cssClass]="'custom'"
                  [preferredCountries]="[CountryISO.Cyprus, CountryISO.Greece]"
                  [enableAutoCountrySelect]="true"
                  [enablePlaceholder]="false"
                  [searchCountryFlag]="true"
          [searchCountryField]="[
            SearchCountryField.Iso2,
            SearchCountryField.Name
          ]"
                  [selectFirstCountry]="false"
                  [maxLength]="16"
                  [phoneValidation]="true"
                  [separateDialCode]="false"
                  name="phone"
                  formControlName="phoneNumber"
                ></ngx-intl-tel-input>
              </div>
            </div>
            @if (
              formGroup.get('username')?.touched && formGroup.get('username')?.invalid
              ) {
              <div
                class="error-message"
                fxLayout="row"
                class="add-patient-row"
                >
                @if (
                  formGroup.get('username')?.touched &&
                  formGroup.get('username')?.invalid
                  ) {
                  <div
                    class="error-message"
                    fxLayout="col"
                    fxFlex="100"
                    class="add-patient-col"
                    >
                    @if (
                      formGroup.get('username')?.touched &&
                      formGroup.get('username')?.invalid
                      ) {
                      <div
                        class="error-message"
                        >
                        @if (formGroup.get('username')?.errors?.['required']) {
                          <div>
                            {{ "Username is required" | translate }}
                          </div>
                        }
                        @if (formGroup.get('username')?.errors?.['pattern']) {
                          <div>
                            {{
                            "Username must be 6-20 characters long and can contain only Latin letters, numbers and the dot symbol (.)"
                            | translate
                            }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
              <div fxLayout="col" fxFlex="100" class="add-patient-col">
                {{ "Email address" | translate }}
                <span class="required-asterisk">*</span>
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
              <div fxLayout="col" fxFlex="100" class="add-patient-col">
                <input
                  class="add-patient-input"
                  [placeholder]="'Email address' | translate"
                  formControlName="email"
                  [maxlength]="101"
                  />
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
                <div fxLayout="col" fxFlex="50" class="add-patient-col">
                  {{ "Role" | translate }}
                  <span class="required-asterisk">*</span>
                </div>
                <div fxLayout="col" fxFlex="50" class="add-patient-col">
                  <div [visible]="filteredSpecialties && filteredSpecialties.length > 0">
                    {{ "Specialty" | translate }}
                    <span class="required-asterisk">*</span>
                  </div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
                <div fxLayout="col" fxFlex="50" class="multiselector">
                  <nz-select
                    nzMode="multiple"
                    class=""
                    style="width: 100%"
                    (ngModelChange)="onRolesChange($event)"
                    formControlName="roles"
                    nzPlaceHolder="{{ 'Roles' | translate }}"
                    >
                    <option disabled selected>{{ "Role" | translate }}</option>
                    @for (role of roles; track role) {
                      <nz-option
                        [nzLabel]="role.translatedName"
                        [nzValue]="role.id"
                      ></nz-option>
                    }
                  </nz-select>
                </div>
                <div fxLayout="col" fxFlex="50" class="multiselector">
                  <nz-select
                    nzMode="multiple"
                    class=""
                    style="width: 100%"
                    formControlName="subRoles"
                    nzPlaceHolder="{{ 'Specialty' | translate }}"
                    [visible]="filteredSpecialties && filteredSpecialties.length > 0"
                    >
                    <option disabled selected>{{ "Specialty" | translate }}</option>
                    @for (specialty of filteredSpecialties; track specialty) {
                      <nz-option
                        [nzLabel]="specialty?.name"
                        [nzValue]="specialty?.id"
                      ></nz-option>
                    }
                  </nz-select>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
                <div fxLayout="col" fxFlex="50" class="add-patient-col">
                  {{ "Language" | translate }}
                  <span class="required-asterisk">*</span>
                </div>
                <div fxLayout="col" fxFlex="50" class="add-patient-col"></div>
              </div>
              <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
                <div fxLayout="col" fxFlex="50" class="add-patient-col">
                  <select class="add-patient-input" formControlName="locale">
                    <option disabled selected>{{ "Language" | translate }}</option>
                    @for (locale of locales; track locale) {
                      <option [value]="locale.id">{{ locale.name }}</option>
                    }
                  </select>
                </div>
                <div fxFlex="col" fxLayout="50" class="add-patient-col"></div>
              </div>
              <div class="buttons" fxFlex="row">
                <div fxFlex="col" fxLayout="50"></div>
                <div fxFlex="col" fxLayout="50" style="width: 100%">
                  <button
                    nz-button
                    class="save-button"
                    type="submit"
                    fxFlex
                    [disabled]="!isFormChanged"
                    >
                    {{ "Save Changes" | translate }}
                  </button>
                  <button
                    nz-button
                    type="button"
                    class="cancel-button"
                    (click)="cancelEdit()"
                    >
                    {{ "Cancel" | translate }}
                  </button>
                </div>
              </div>
              <div class="mail-section" fxFlex="row">
                <div fxFlex="col" fxLayout="50"></div>
                <div fxFlex="col" fxLayout="50">
                  <!-- Show the 'Send Mail' button only if requiredActions is true -->
                  @if (editedUser.requiredActions) {
                    <button
                      nz-button
                      color="warn"
                      class="email-button"
                      (click)="sendMail()"
                      type="button"
                      fxFlex
                      >
                      {{ "Send Via Mail Account Credentials" | translate }}
                    </button>
                  }
                </div>
              </div>
            </form>
          </div>
        }

        @if (loading) {
          <div class="loading-container">
            <!-- Centered loading spinner -->
            <div class="loading-text">
              <p>{{ "Loading..." | translate }}</p>
            </div>
            <mat-spinner></mat-spinner>
          </div>
        }
